import { DraftPlaceholderTextConfiguration } from '@/types';

export const updatePlaceholderSize = (
  configuration: DraftPlaceholderTextConfiguration,
  placeholderWidth = configuration.placeholderSize.width
) => {
  const { width, height } = configuration.size;
  configuration.placeholderSize.width = Math.max(width, placeholderWidth);
  configuration.placeholderSize.height = height;
  configuration.placeholderCenter = {
    x: configuration.offset.x + width / 2,
    y: configuration.offset.y + height / 2,
  };
};
